
import CalSubsDeliveryDates from "../cart-dialog/cal-subs-delivery-dates";
import CalRecipientDetails from "../cart-dialog/cal-recipient-details";
import CalDeliveryWindow from "../cart-dialog/cal-delivery-window";
import CalSub6CardMessage from "../cart-dialog/cal-sub6-card-message";
import CalSubsCartDialogSteps from '../cart-dialog/cal-subs-cart-dialog-steps.vue';
import CalSubsCollection from "../cart-dialog/cal-subs-collection";
import CalSubsSize from "../cart-dialog/cal-subs-size";
import CalSub6Frequency from "../cart-dialog/cal-sub6-frequency";
import { DELUXE_SIZE,SIGNATURE_COLLECTION } from "@/utils/shopify";
import { butter } from "../../plugins/buttercms";

export default {
  name: "cal-subscription-mday-checkout",
  components: {
    CalSubsDeliveryDates,
    CalRecipientDetails,
    CalDeliveryWindow,
    CalSub6CardMessage,
    CalSubsCartDialogSteps,
    CalSubsSize,
    CalSub6Frequency,
    CalSubsCollection,
  },
  data() {
    return {
      subsData: {},
      workflow: "SUBSCRIPTION",
      config: {
        displayAddons: false,
        displayVases: false,
        displayDonation: false,
        displayGreets: false,
        autoSelectGreets:false,
      },
      steps: [
       {
          name: "collection_select",
        },
        {
          name: "size_select",
        },
        {
          name: "recipient_details",
        },
        {
          name: "delivery_dates",
        },
        {
          name: "delivery_window",
        },
        {
          name: "sub6_card_message",
        }
      ],
    };
  },
  props: {
    showCartDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    subscriptionTimePeriod: {
      type: Number,
      required: true,
      default: 0,
    },
    isLoadAddons:{
      type: Boolean,
      required: true
    },
    isReLoadRecipientDialog:{
     type:Boolean,
     required: true
    }

  },
  methods: {
    closeCartDialog() {
      this.$emit("closeCartDialog");
    },
  },
  computed: {
    subscriptionPeriod() {
      return 3
    },
  },
  created() {
    this.$store.dispatch("cartItem/SUB_VARIANT_SET", DELUXE_SIZE);
    this.$store.dispatch("cartItem/SUB_COLLECTION_SET", SIGNATURE_COLLECTION)
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve("*", "subscription-dialog", {
        locale: this.$i18n.getLocaleCookie(),
        timeout: 10000
      });
      this.subsData = page?.data.data.fields;
    } catch (error) {
      console.error(error);
    }
  },
};
